import React, { useState, useEffect } from 'react';

import { makeStyles } from "@material-ui/core/styles";
import TableSpc from "components/TableSpc/TableSpc.js";
import { Modal, Form, Col, Button } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import moment from 'moment';
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import GetAppIcon from "@material-ui/icons/GetApp";
import FileUploadIcon from "@material-ui/icons/Publish";
import DoneIcon from "@material-ui/icons/Done";
import ClearIcon from "@material-ui/icons/Clear";
import { Input } from '@material-ui/core';
import CardIcon from "components/Card/CardIcon.js";
import Icon from "@material-ui/core/Icon";

import useAuth from "hooks/useAuth";

import api from "assets/services/api";

import ModalAddOccurrenceType from 'components/ModalAddOccurrenceType/ModalAddOccurrenceType';


const styles4 = {
    tp: {
        marginTop: "10px",
    },
    upload: {
        fontSize: "16px",
        fontWeight: "bold",
        color: "#000000",
        backgroundColor: "transparent",
        marginTop: "10px",
        border: "none",
    },
    container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    }
};

const useStyles2 = makeStyles(styles2);
const useStyles4 = makeStyles(styles4);

function ModalViewOccurrenceType(props) {

    const classes2 = useStyles2();
    const classes4 = useStyles4();
    const { storageId, user } = useAuth();
    const [index, setIndex] = useState({ id: 0 });
    const [occurrenceTypes, setOccurrenceTypes] = useState([]);
    const [modalShowAdd, setModalShowAdd] = useState(false);

    useEffect(() => {
        getOccurrenceType();
    }, []);

    async function getOccurrenceType() {
        const response = await api.get(`/occurrence/type/${storageId}?page=1&pageSize=200&search=`);
        if (response.data.occurrences.length > 0) {
            console.log("if api")
            setOccurrenceTypes(response.data.occurrences);
        }
    }

    function tableOccurrenceTypes() {
        let teste = [];

        for (let i = 0; i < occurrenceTypes.length; i++) {
            teste[i] = [];
            teste[i].push(occurrenceTypes[i].tittle);
            teste[i].push(occurrenceTypes[i].username);
            teste[i].push(moment(occurrenceTypes[i].created_at).format('DD/MM/YYYY'));
            teste[i].push(
                <CardIcon>
                    <Icon title={occurrenceTypes[i].enable ? "Validado" : "Não validado"}>{occurrenceTypes[i].enable ? "done" : "clear"}</Icon>
                </CardIcon>
            );
        };
        return teste;
    };

    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Titulos de Ocorrencias
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <TableSpc
                    tableHeaderColor="primary"
                    tableHead={["Titulo", "Criado por", "Data criação", "Status"]}
                    tableData={tableOccurrenceTypes()}
                />
            </Modal.Body>
            <Modal.Footer>
                <Form.Group as={Col} controlId="formGridName" className="d-flex justify-content-center">
                    <Button onClick={() => setModalShowAdd(true)}>NOVO TITULO</Button>
                </Form.Group>
            </Modal.Footer>
            <ModalAddOccurrenceType key={"add_occurrenceType"} show={modalShowAdd} onHide={() => setModalShowAdd(false)} loadOccurrenceType={() => getOccurrenceType()} />
        </Modal>
    );
}

export default ModalViewOccurrenceType;